module.exports = __webpack_public_path__ + "static/img/img-1.2b2874be.jpg";